export default {
  debug: false,
  basepath: 'http://tsomi.cloudcity.io/',
}



// WEBPACK FOOTER //
// ./src/config.js